/**
 * Currency API
 * Hooks and functions for currency conversion operations
 */
import { useQuery, useMutation } from "@1f/react-sdk";
import { query_getCurrencies, mutation_convertToEur } from "../query/currencyQueries";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";

export const CurrencyApi = () => {
    const errorApiHelpers = apiErrorHelper();
    const getCurrenciesQuery = useQuery(
        query_getCurrencies,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const convertToEurMutation = useMutation(mutation_convertToEur, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });

    /**
     * Get list of available currencies
     * @returns {Promise<Array>} Array of currency objects with code, name, and symbol
     */
    const getCurrencies = async () => {
        try {
            const response = await getCurrenciesQuery.fetch({});
            
            if (response?.data?.data?.getCurrencies) {
                return response.data.data.getCurrencies;
            }
            
            return [];
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le valute: " + error.message);
        }
    };
    /**
     * Convert an amount from a specific currency to EUR
     * @param {string} isoCode - Currency ISO code (e.g., "USD")
     * @param {number} amount - Amount to convert
     * @param {string} conversionDate - Date for conversion (ISO format)
     * @returns {Promise<Object>} Conversion result with convertedAmount, exchangeRate, etc.
     */
    const convertToEur = async (isoCode, amount, conversionDate) => {
        try {
            const response = await convertToEurMutation.fetch({
                isoCode,
                amount,
                conversionDate
            });
            
            if (response?.data?.data?.convertToEur) {
                return response.data.data.convertToEur;
            }
            
            return null;
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile convertire la valuta selezionata: " + error.message);
        }
    };

    return {
        getCurrencies,
        convertToEur
    };
};
